export default [
    'Client', 'Program Proposal', 'Session Notes', 'Actions', 'Progress', 'Road Map', 'Document Storage', 'Notes', 'Timesheet'
]
